export function getBroswerAndVersion () {
  let userAgent = navigator.userAgent
  let info = ''
  let tempArray
  //判断浏览器版本
  let isOpera = userAgent.indexOf('Opera') > -1 //判断是否Opera浏览器
  let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera //判断是否IE浏览器
  let isEdge = userAgent.toLowerCase().indexOf('edge') > -1 && !isIE //判断是否IE的Edge浏览器
  let isIE11 = (userAgent.toLowerCase().indexOf('trident') > -1 && userAgent.indexOf('rv') > -1)
  if (/[Ff]irefox(\/\d+\.\d+)/.test(userAgent)) {  
    tempArray = /([Ff]irefox)\/(\d+\.\d+)/.exec(userAgent)
    info += tempArray[1] + tempArray[2]
  } else if (isIE) {  
    let version = ''
    let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    let fIEVersion = parseFloat(RegExp['$1'])
    switch (fIEVersion) {
      case 7:
        version = 'IE7'
        break
      case 8:
        version = 'IE8'
        break
      case 9:
        version = 'IE9'
        break
      case 10:
        version = 'IE10'
        break     
      default:
        version = '0'
        break
    } 
    info += version
  } else if (isEdge) {  
    info += 'Edge' 
  } else if (isIE11) {  
    info += 'IE11' 
  } else if (/[Cc]hrome\/\d+/.test(userAgent)) {  
    tempArray = /([Cc]hrome)\/(\d+)/.exec(userAgent)
    info += tempArray[1] + tempArray[2]
  } else if (/[Vv]ersion\/\d+\.\d+\.\d+(\.\d)* *[Ss]afari/.test(userAgent)) {  
    tempArray = /[Vv]ersion\/(\d+\.\d+\.\d+)(\.\d)* *([Ss]afari)/.exec(userAgent)
    info += tempArray[3] + tempArray[1]
  } else if (/[Oo]pera.+[Vv]ersion\/\d+\.\d+/.test(userAgent)) {  
    tempArray = /([Oo]pera).+[Vv]ersion\/(\d+)\.\d+/.exec(userAgent)
    info += tempArray[1] + tempArray[2]
  } else {  
    info += 'unknown'
  }  
  return info.toLocaleLowerCase()
}

export function isLowVersionBrowser () {
  let browser = getBroswerAndVersion()
  let bol = false
  if (browser.indexOf('ie') >= 0 && parseFloat(browser.replace(/ie/g, '')) < 11) {
    bol = true
  } else if (browser.indexOf('chrome') >= 0 && parseFloat(browser.replace(/chrome/g, '')) < 29) {
    bol = true
  } else if (browser.indexOf('firefox') >= 0 && parseFloat(browser.replace(/firefox/g, '')) < 28) {
    bol = true
  } else if (browser.indexOf('safari') >= 0 && parseFloat(browser.replace(/safari/g, '')) < 6.1) {
    bol = true
  } else if (browser.indexOf('opera') >= 0 && parseFloat(browser.replace(/opera/g, '')) < 17) {
    bol = true
  }
  return bol
}

export function isMobileWechat () {
  const ua = navigator.userAgent.toLowerCase()
  const match = ua.match(/MicroMessenger/i)
  if (match && match.includes('micromessenger') && (ua.match(/(iPhone|iPod|iPad);?/i) || ua.match(/android/i))) return true
  return false
}

export function delay (time = 0) {
  time = time < 100 ? 0 : time
  return new Promise((resolve) => {
    if (!time) {
      resolve(true)
    } else {
      setTimeout(() => {
        resolve(true)
      }, time)
    }
  })
}